const menu = [
    {
        label: 'Support IT',
        icon: 'fa-question-circle',
        role: ['customer'],
        to: process.env.VUE_APP_SUPPORT,
        target: true
    },
    {
        label: 'Mon profil',
        icon: 'fa-user',
        role: 'all',
        to: process.env.VUE_APP_PROFILE,
        target: false
    },
    {
        label: 'Documents',
        icon: 'fa-files-o',
        role: ['customer'],
        target: false,
        children: [
            {
                label: 'Liste des documents',
                icon: 'fa-file-text',
                role: ['customer'],
                to: process.env.VUE_APP_DOCUMENT_LIST
            },
            {
                label: "Plateforme de validation",
                icon: 'fa-flag-checkered',
                role: ['customer'],
                to: process.env.VUE_APP_DOCUMENT_PLATFORM
            }
        ]
    },
    {
        label: 'Message Bird',
        icon: 'fa-phone-square',
        role: ['customer'],
        target: false,
        children: [
            {
                label: 'Liste',
                icon: 'fa-list',
                role: ['customer'],
                to: process.env.VUE_APP_MESSAGE_LIST
            },
            {
                label: "Nouveau",
                icon: 'fa-plus',
                role: ['customer'],
                to: process.env.VUE_APP_MESSAGE_NEW
            }
        ]
    },
    {
        label: 'Carizy employé',
        icon: 'fa-user-secret',
        role: ['customer'],
        target: false,
        children: [
            {
                label: "Liste des commerciaux",
                icon: 'fa-list',
                role: ['customer'],
                to: process.env.VUE_APP_ACCOUNT_MANAGER_LIST
            },
            {
                label: "Liste des office manager",
                icon: 'fa-list',
                role: ['customer'],
                to: process.env.VUE_APP_OFFICE_MANAGER_LIST
            },
            {
                label: 'Nouveau Commercial',
                icon: 'fa-plus',
                role: ['customer'],
                to: process.env.VUE_APP_ACCOUNT_MANAGER_NEW
            },
            {
                label: 'Nouvel Office Manager',
                icon: 'fa-plus',
                role: ['customer'],
                to: process.env.VUE_APP_OFFICE_MANAGER_NEW
            }
        ]
    },
    {
        label: 'Clients',
        icon: 'fa-users',
        role: ['customer'],
        target: false,
        children: [
            {
                label: 'Liste des clients',
                icon: 'fa-list',
                role: ['customer'],
                to: process.env.VUE_APP_CUSTOMER_LIST
            }
        ]
    },
    {
        label: 'Véhicules',
        icon: 'fa-car',
        role: ['customer'],
        target: false,
        children: [
            {
                label: 'Liste des véhicules',
                icon: 'fa-list',
                role: ['customer'],
                to: process.env.VUE_APP_VEHICULES_LIST
            },
            {
                label: "Evolution des prix",
                icon: 'fa-usd',
                role: ['customer'],
                to: process.env.VUE_APP_VEHICULES_PRICE_VARIATION
            },
            {
                label: "Appel VIN",
                icon: 'fa-toggle-up',
                role: ['customer'],
                to: process.env.VUE_APP_CALL_VIN
            }
        ]
    },
    {
        label: 'Tableau de bord',
        icon: 'fa-check-square',
        role: ['expert', 'expert_feuvert', 'manager', 'manager_feuvert', 'expert_renault', 'manager_renault'],
        target: false,
        to: process.env.VUE_APP_DASHBOARD
    },
    {
        label: 'Expertises',
        icon: 'fa-gear',
        role: ['customer'],
        target: false,
        children: [
            {
                label: 'Nouveau RDV',
                icon: 'fa-edit',
                to: process.env.VUE_APP_RDV_NEW
            },
            {
                label: "Les RDV d'expertises",
                icon: 'fa-list',
                to: process.env.VUE_APP_RDV_LIST_PRO
            },
            {
                label: "Expertise à intégrer",
                icon: 'fa-cog',
                to: process.env.VUE_APP_RDV_TO_INTEGRATE
            },
        ]
    },
    {
        label: 'Cabinets',
        icon: 'fa-archive',
        role: ['customer'],
        target: false,
        children: [
            {
                label: 'Ajouter un expert',
                icon: 'fa-user-plus',
                role: ['customer'],
                to: process.env.VUE_APP_EXPERT_NEW
            },
            {
                label: "Liste des experts",
                icon: 'fa-list-alt',
                role: ['customer'],
                to: process.env.VUE_APP_EXPERT_LIST
            }
        ]
    },
    {
        label: 'Call Center',
        icon: 'fa-phone',
        role: ['customer'],
        target: false,
        children: [
            {
                label: 'Liste des conseillers',
                icon: 'fa-list',
                to: process.env.VUE_APP_CALL_CENTER_LIST
            },
            {
                label: 'Liste des managers',
                icon: 'fa-list',
                to: process.env.VUE_APP_CALL_CENTER_MANAGER_LIST
            },
            {
                label: "Nouveau conseiller",
                icon: 'fa-user-plus',
                to: process.env.VUE_APP_CALL_CENTER_NEW
            },
            {
                label: "Ajouter un manager",
                icon: 'fa-user-plus',
                to: process.env.VUE_APP_CALL_CENTER_MANAGER_NEW
            }
        ]
    },
    {
        label: 'Commandes',
        icon: 'fa-list-alt',
        role: ['customer'],
        target: false,
        children: [
            {
                label: 'Liste des commandes',
                icon: 'fa-list',
                role: ['customer'],
                to: process.env.VUE_APP_NEW_COMMAND_LIST
            },
            {
                label: 'Ajouter une commande',
                icon: 'fa-plus',
                role: ['customer'],
                to: process.env.VUE_APP_COMMAND_CREATE
            }
        ]
    },
    {
        label: 'Formation et Documents',
        icon: 'fa-graduation-cap',
        role: ['customer'],
        target: false,
        to: process.env.VUE_APP_FORMATION
    },
    {
        label: 'Déconnexion',
        icon: 'fa-sign-out',
        role: 'all',
        target: false,
        to: process.env.VUE_APP_BACKOFFICE_LOGOUT
    }
]

export default menu
